import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "16",
  viewBox: "0 0 20 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4A4A4A",
      "fill-rule": "evenodd",
      d: "M0 0h20v2.191H0zm0 7.591V5.452h20v2.14H0zm0 5.452v-2.19h20v2.19z"
    }, null, -1)
  ]))]))
}
export default { render: render }